import * as z from "zod";

export enum IssueState {
  TODO = "todo",
  IN_PROGRESS = "inprogress",
  DONE = "done",
  WONTDO = "wontdo",
}

export enum IssueType {
  GROUP = "group",
  ISSUE = "issue",
  TASK = "task",
}

export const issueSchema = z.object({
  identifier: z.number().int().positive(),
  title: z.string(),
  description: z.string().optional(),
  tags: z.array(z.string()),
  state: z.nativeEnum(IssueState),
  type: z.nativeEnum(IssueType),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Issue = z.infer<typeof issueSchema>;
